<template>
  <v-dialog :value="dialog" @click:outside="cancelDialog()" max-width="850">
    <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
      <v-card>
        <v-progress-linear v-if="isLoading" indeterminate color="primary" rounded height="6"></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} Tipificación

              <v-spacer></v-spacer>

              <v-btn icon @click="dataChannel">
                <v-icon>mdi-cached</v-icon>
              </v-btn>
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 350px">
            <v-form>
              <v-row>
                <!-- Colas -->
                <v-col cols="12" class="py-0">
                  <ValidationProvider rules="required" name="Colas" v-slot="{ errors }" tag="div">
                    <v-select
                      :disabled="isLoading"
                      v-model="formData.queue_id"
                      :items="queues"
                      item-text="name"
                      item-value="id"
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Colas"
                      prepend-inner-icon="mdi-database"
                      color="info"
                      :error-messages="errors"
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <!-- Tipificacion (Nivel 1) -->
                <v-col cols="12" class="py-0">
                  <ValidationProvider rules="required" name="tipificación" v-slot="{ errors }" tag="div">
                    <v-select
                      :disabled="isLoading"
                      v-model="formData.typification_id"
                      :items="TypificationList"
                      item-text="name"
                      item-value="id"
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Tipificacion"
                      prepend-inner-icon="mdi-label"
                      color="info"
                      :error-messages="errors"
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <!-- Categoría (Nivel 2) -->
                <v-col cols="12" class="py-0">
                  <ValidationProvider rules="required" name="Categoría" v-slot="{ errors }" tag="div">
                    <v-select
                      :disabled="isLoading"
                      v-model="firstChildId"
                      :items="ChildrenList"
                      item-text="name"
                      item-value="id"
                      class="rounded-small"
                      label="Categoría"
                      prepend-inner-icon="mdi-label"
                      color="info"
                      no-data-text="Debe seleccionar una tipificacion primero"
                      :error-messages="errors"
                      :loading="!secondChildId && isLoadingChilds"
                      dense
                      filled
                      rounded
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <!-- Hijo de hijo (Nivel 3)-->
                <v-fade-transition>
                  <v-col cols="12" class="py-0" v-if="firstChildId && childLevel3List.length">
                    <v-select
                      :disabled="isLoading"
                      v-model="secondChildId"
                      :items="childLevel3List"
                      item-text="name"
                      item-value="id"
                      class="rounded-small"
                      label="Hijo de Hijo"
                      prepend-inner-icon="mdi-label"
                      color="info"
                      :error-messages="errors"
                      :loading="isLoadingChilds"
                      dense
                      filled
                      rounded
                    ></v-select>
                  </v-col>
                </v-fade-transition>
                <!-- Nivel 4 -->
                <v-fade-transition>
                  <v-col cols="12" class="py-0" v-if="secondChildId && childLevel4List.length">
                    <v-select
                      :disabled="isLoading"
                      v-model="thirdChildId"
                      :items="childLevel4List"
                      item-text="name"
                      item-value="id"
                      class="rounded-small"
                      label="Nivel 4"
                      prepend-inner-icon="mdi-label"
                      color="info"
                      :error-messages="errors"
                      dense
                      filled
                      rounded
                    ></v-select>
                  </v-col>
                </v-fade-transition>
                <!-- Valor -->
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="formData.value"
                    :disabled="isLoading"
                    label="Valor"
                    prepend-inner-icon="mdi-numeric"
                    class="rounded-small"
                    filled
                    rounded
                    hide-details
                  ></v-text-field>
                </v-col>
                <!-- Extension -->
                <v-col v-if="!extensionField" cols="12" class="pb-0 pt-4">
                  <v-text-field
                    v-model="ext"
                    :disabled="isLoading"
                    label="Extension"
                    prepend-inner-icon="mdi-numeric"
                    class="rounded-small"
                    filled
                    rounded
                    hide-details
                  ></v-text-field>
                </v-col>

                <!-- Comentarios -->
                <v-col cols="12" class="pt-5">
                  <v-textarea
                    v-model="formData.comments"
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    label="Comentarios"
                    prepend-inner-icon="mdi-format-align-justify"
                    color="info"
                    rows="3"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="justify-space-between align-center flex-wrap flex-md-nowrap">
          <v-col cols="12" md="auto" class=" pt-0 mt-1 pr-0">
            <v-radio-group v-model="formData.type" row class="mt-0" :disabled="formData.bridgechan == ''" hide-details>
              <v-radio label="Colgar" value="1"></v-radio>
              <v-radio label="Buzón" value="2"></v-radio>
              <v-radio label="Encuesta" value="3"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="auto" class="pt-0 mt-3 px-0">
            <v-checkbox
              label="Auditar"
              class="mt-0"
              v-model="formData.audit"
              :false-value="0"
              :true-value="1"
              hide-details
            ></v-checkbox>
          </v-col>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              :disabled="isLoading || isLoadingChilds"
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="cancelDialog()"
              >Cancelar</v-btn
            >
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading || isLoadingChilds"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="handleSubmit(submitForm)"
            >
              {{ isEditMode ? "Actualizar" : "Crear" }}
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
export default {
  props: {
    dialog: {
      type: Boolean,
    },
    temporaryTableId: {
      type: Number,
    },
    queueNumber: {
      type: Number,
    },
    dataToEdit: {
      type: Object,
    },
    isEditMode: {
      type: Boolean,
    },
    typificationId: {
      type: Number,
    },
  },

  components: { vuescroll },

  data() {
    return {
      isLoading: false,
      isLoadingChilds: false,
      queues: [],
      childLevel3List: [],
      childLevel4List: [],
      firstChildId: null,
      secondChildId: null,
      thirdChildId: null,
      ext: "",
      formData: {
        queue_id: null,
        typification_id: null,
        children_id: null,
        temporaryTable_id: this.temporaryTableId,
        type: null,
        bridgechan: "",
        audit: 0,
      },
    };
  },
  computed: {
    User() {
      return this.$store.getters["passport/CURRENT_USER"];
    },
    TypificationList() {
      return this.formData.queue_id ? this.queues.find((el) => el.id === this.formData.queue_id).typification : [];
    },
    ChildrenList() {
      return this.formData.typification_id
        ? this.TypificationList.find((el) => el.id === this.formData.typification_id).children
        : [];
    },
    extensionField() {
      return this.User.extension || this.User.variable || null;
    },
  },

  created() {
    if (this.isEditMode) {
      this.formData = this.dataToEdit;
      // this.ext = this.dataToEdit.ext;
    }
    this.getQueues();
  },

  watch: {
    firstChildId(val) {
      this.getDeepChild(val, 2);
      this.secondChildId = null;
      this.thirdChildId = null;
      this.childLevel3List = [];
    },
    secondChildId(val) {
      this.getDeepChild(val, 3);
      this.thirdChildId = null;
      this.childLevel4List = [];
    },
  },

  methods: {
    cancelDialog() {
      if (this.isLoading || this.isLoadingChilds) return;
      this.$emit("close:dialog");
    },
    async getQueues() {
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get(`/clients/queues`);
        // console.log("data:", data);
        if (this.queueNumber != null) {
          this.formData.queue_id = data.data.find((q) => q.number === this.queueNumber)?.id;
        }
        this.queues = data.data;

        if (this.TypificationList.length > 0) this.formData.typification_id = this.TypificationList[0].id;

        if (this.ChildrenList.length > 0) this.firstChildId = this.ChildrenList[0].id;
      } catch (err) {
        console.log("error:", err);
      }
      this.isLoading = false;
    },

    async getDeepChild(children_id, level = 2) {
      this.isLoadingChilds = true;
      try {
        const { data } = await PbxHttpClient.post(`/clients/typification/show`, {
          children_id,
        });

        if (level === 2) {
          this.childLevel3List = data.data.descendants;
        }

        if (level === 3) {
          this.childLevel4List = data.data.descendants;
        }
      } catch (err) {
        console.log("error:", err);
      }
      this.isLoadingChilds = false;
    },

    async dataChannel() {
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get(`/typing/data_channel`);

        if (data.data.BRIDGECHAN != "") this.formData.bridgechan = data.data.BRIDGECHAN;
        // console.log("data:", data);
      } catch (err) {
        console.log("error:", err);
      }
      this.isLoading = false;
    },

    async submitForm() {
      this.isLoading = true;
      try {
        // await PbxHttpClient.post(`/typing/register_typing_call`, {
        //   ...this.formData,
        //   children_id: this.secondChildId ?? this.firstChildId,
        //   ext: this.extensionField || this.ext,
        // });

        const payload = {
          ...this.formData,
          children_id: this.thirdChildId ?? this.secondChildId ?? this.firstChildId,
          ext: this.extensionField || this.ext,
        };

        this.isEditMode
          ? await PbxHttpClient.put(`/typing/update_typing_call/${this.typificationId}`, payload)
          : await PbxHttpClient.post("/typing/register_typing_call", payload);

        // console.log("response:", data);
        this.$snotify.success(`Tipificación ${this.isEditMode ? "Actualizada" : "Creada"} con éxito.`, "¡Hecho!");
        this.$emit("close:dialog", true);
      } catch (err) {
        this.$snotify.error("No se pudo guardar los datos.", "Error");
        // console.log("err:", err);
      }
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
